module.exports = __webpack_public_path__ + "img/carousel-clientes-11.e558565a.png";